/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import Header from '../components/static/Header';
import Button from '../components/elements/Button';
import Sidebar from '../components/static/Sidebar';
import { useNavigate } from 'react-router-dom';
import NavbarButton from '../components/elements/NavbarButton';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import SmartToyRoundedIcon from '@mui/icons-material/SmartToyRounded';
import AnalyticsRoundedIcon from '@mui/icons-material/AnalyticsRounded';
import CodeIcon from '@mui/icons-material/Code';
// import SettingsRoundedIcon from '@mui/icons-material/SettingsRounded';
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import CreateAssistant from '../components/screens/CreateAssistant';
import Assistants from '../components/screens/Assistants';
import Analytics from '../components/screens/Analytics';
import Account from '../components/screens/Account';
import Dashboard from '../components/screens/Dashboard';
import { useProduct } from '../context/ProductContext';
import CreateSiteAssistant from '../components/screens/Site/CreateSiteAssistant';
import Embed from '../components/screens/Embed';
import CreateCanvasAssistant from '../components/screens/Canvas/CreateCanvasAssistant';

enum ScreenType {
  Dashboard = 'DASHBOARD',
  CreateBot = 'CREATEBOT',
  Assistants = 'ASSISTANTS',
  Analytics = 'ANALYTICS',
  Embed = 'EMBED',
  Account = 'ACCOUNT',
  Settings = 'SETTINGS'
}
interface Props {
}

const Home: React.FC<Props> = (Props) => {
    const { product, isProduct } = useProduct();
    const navigate = useNavigate();
    const [currentScreen, setCurrentScreen] = useState(ScreenType.Dashboard)
    const [selectedBotId, setSelectedBotId] = useState<string | undefined>(undefined);

    const handleNavigateToAnalytics = (botId: string) => {
        setSelectedBotId(botId);
        setCurrentScreen(ScreenType.Analytics)
    };

    const handleNavigateToAssistants = () => {
        setCurrentScreen(ScreenType.Assistants)
    };
    const handleLogout = () => {
        // Clear tokens, redirect, etc.
        navigate('/login');
    };
    return (
        <div className="">
            <div>
                <Header title="ComeChatWithMe.ai" rightElement={
                    <Button
                        backgroundColor='#ffffff'
                        color='var(--primary)'
                        width='200px'
                        height='50px'
                        fontSize='20px'
                        label="Create Assistant +"
                        onClick={() => setCurrentScreen(ScreenType.CreateBot)}
                    />
                } />
            </div>
            <div>
                <Sidebar onLogout={handleLogout}>
                    <NavbarButton
                        text="Dashboard"
                        icon={HomeRoundedIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="var(--primary)"
                        color="#fff"
                        onClick={() => setCurrentScreen(ScreenType.Dashboard)}
                    />
                     <NavbarButton
                        text="Create"
                        icon={AddCircleRoundedIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="var(--primary)"
                        color="#fff"
                        onClick={() => setCurrentScreen(ScreenType.CreateBot)}
                    />
                    <NavbarButton
                        text="Assistants"
                        icon={SmartToyRoundedIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="var(--primary)"
                        color="#fff"
                        onClick={() => setCurrentScreen(ScreenType.Assistants)}
                    />
                    <NavbarButton
                        text="Analytics"
                        icon={AnalyticsRoundedIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="var(--primary)"
                        color="#fff"
                        onClick={() => setCurrentScreen(ScreenType.Analytics)}
                    />
                    <NavbarButton
                        text="Embed"
                        icon={CodeIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="var(--primary)"
                        color="#fff"
                        onClick={() => setCurrentScreen(ScreenType.Embed)}
                    />
                    <NavbarButton
                        text="Account"
                        icon={AccountCircleIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="var(--primary)"
                        color="#fff"
                        onClick={() => setCurrentScreen(ScreenType.Account)}
                    />
{/*                     <NavbarButton
                        text="Settings"
                        icon={SettingsRoundedIcon}
                        fontSize="18px"
                        fontWeight={600}
                        backgroundColor="var(--primary)"
                        color="#fff"
                        onClick={() => setCurrentScreen(ScreenType.Settings)}
                    /> */}
                    
                </Sidebar>
                {product === null || product === 'resume' ?
                <>
                    { currentScreen === ScreenType.Dashboard ? <Dashboard onSelectAnalytics={handleNavigateToAnalytics} goToAssistants={handleNavigateToAssistants}></Dashboard>: null}
                    { currentScreen === ScreenType.CreateBot ? <CreateAssistant goToAssistants={handleNavigateToAssistants}></CreateAssistant>: null}
                    { currentScreen === ScreenType.Assistants ? <Assistants onSelectAnalytics={handleNavigateToAnalytics}></Assistants>: null}
                    { currentScreen === ScreenType.Embed ? <Embed></Embed>: null}
                    { currentScreen === ScreenType.Analytics ? <Analytics defaultStartinBotId={selectedBotId}></Analytics>: null}
                    { currentScreen === ScreenType.Account ? <Account ></Account>: null}
                </> : null
                }
                {product === 'site-assistant' ?
                <>
                    { currentScreen === ScreenType.Dashboard ? <Dashboard onSelectAnalytics={handleNavigateToAnalytics} goToAssistants={handleNavigateToAssistants}></Dashboard>: null}
                    { currentScreen === ScreenType.CreateBot ? <CreateSiteAssistant goToAssistants={handleNavigateToAssistants}></CreateSiteAssistant>: null}
                    { currentScreen === ScreenType.Assistants ? <Assistants onSelectAnalytics={handleNavigateToAnalytics}></Assistants>: null}
                    { currentScreen === ScreenType.Embed ? <Embed></Embed>: null}
                    { currentScreen === ScreenType.Analytics ? <Analytics defaultStartinBotId={selectedBotId}></Analytics>: null}
                    { currentScreen === ScreenType.Account ? <Account ></Account>: null}
                </> : null
                }
                {product === 'bot-canvas' ?
                <>
                    { currentScreen === ScreenType.Dashboard ? <Dashboard onSelectAnalytics={handleNavigateToAnalytics} goToAssistants={handleNavigateToAssistants}></Dashboard>: null}
                    { currentScreen === ScreenType.CreateBot ? <CreateCanvasAssistant goToAssistants={handleNavigateToAssistants}></CreateCanvasAssistant>: null}
                    { currentScreen === ScreenType.Assistants ? <Assistants onSelectAnalytics={handleNavigateToAnalytics}></Assistants>: null}
                    { currentScreen === ScreenType.Embed ? <Embed></Embed>: null}
                    { currentScreen === ScreenType.Analytics ? <Analytics defaultStartinBotId={selectedBotId}></Analytics>: null}
                    { currentScreen === ScreenType.Account ? <Account ></Account>: null}
                </> : null
                }
                
            </div>
            
        </div>
    )
}

export default Home
